import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../Context';
import CustomToolTip from './ToolTipInfoCustomMUI';
import Zoom from '@mui/material/Zoom';
import { ReactComponent as IconClose } from '../media/img/icon-close.svg';
import styles from '../styles/aprt.module.scss';

const ComponentCloseButton = ({ flag }) => {
	const { t } = useTranslation();

	const {
		tiersData,
		activeTier,
		setActiveTier,

		activeApartment,
		setActiveApartment,
		setActiveApartmentHandle,
		isDesktop,
		isMobile,
	} = useContext(Context);

	const containerStyles = {
		position: 'absolute',
		top: flag === 'apartment' || flag === 'tier' ? 'var(--section-padding)' : '0',
		right: '0',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 20,
	};

	const handleClose = (flag) => {
		switch (flag) {
			case 'apartment':
				setActiveApartmentHandle(null);
				document
					.getElementById('tiers')
					.scrollIntoView({ behavior: 'smooth', block: 'start' });
				break;
			case 'tier':
				setActiveTier(null);
				setActiveApartmentHandle(null);
				const modelElement = document.getElementById('model');
				const visualizationElement = document.getElementById('visualisations');
				if (!modelElement) {
					visualizationElement.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});
				} else
					modelElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
				break;
			default:
				break;
		}
	};

	const getToolTipText = (flag) => {
		switch (flag) {
			case 'apartment':
				return t('close_apartment_view');
			case 'tier':
				return t('close_tier_view');
			default:
				return t('close_section');
		}
	};

	return (
		<CustomToolTip
			title={
				getToolTipText(flag)
			}
			slots={{
				transition: Zoom,
			}}
			arrow
		>
			<div style={containerStyles}>
				<button
					className={`${styles.planButton} ${styles.planButton__cta}`}
					onClick={() => handleClose(flag)}
				>
					<IconClose
						title="zamknij sekcję" //TODO: add to locales
						className={`${styles.planButton__icon} ${styles.planButton__icon_large}`}
					/>
				</button>
			</div>
		</CustomToolTip>
	);
};

export default ComponentCloseButton;
